import { createFileRoute, notFound } from "@tanstack/react-router";
import { EmentaQualifierForm } from "@/components/ementas/EmentaQualifierForm";
import { POS_THEMES } from "@/components/posfigma/theme";
import { POS_INFO } from "@/lib/checkout/links";
import type { CSSProperties } from "react";

const SLUGS = ["orto", "dor", "esporte", "geronto", "trauma", "prescricao"] as const;
type Slug = (typeof SLUGS)[number];

function isSlug(s: string): s is Slug {
  return (SLUGS as readonly string[]).includes(s);
}

export const Route = createFileRoute("/embed/ementa/$slug")({
  head: () => ({
    meta: [
      { title: "Baixar ementa" },
      { name: "description", content: "Preencha seus dados para baixar em PDF a ementa completa da pós-graduação escolhida: módulos, professores e cronograma." },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [
      { rel: "preconnect", href: "https://pfzkgqaoufsyvhvwzqtk.supabase.co", crossOrigin: "anonymous" },
    ],
  }),
  component: EmbedEmentaPage,
});

const EMBED_FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

function EmbedEmentaPage() {
  const { slug } = Route.useParams();
  if (!isSlug(slug)) throw notFound();
  const theme = POS_THEMES[slug];
  const info = POS_INFO[slug];
  const style = {
    "--primary": theme.primary,
    "--primary-foreground": "#ffffff",
    fontFamily: EMBED_FONT_STACK,
  } as CSSProperties;

  return (
    <div
      className="min-h-screen w-full px-4 py-6 sm:px-6 sm:py-8 bg-[#13123a] text-white"
      style={style}
    >
      <div className="mx-auto max-w-md rounded-2xl border border-white/10 bg-[#1b1a4a] p-5 sm:p-6 shadow-2xl">
        <EmentaQualifierForm product={slug} posUrl={info.wix} />
      </div>
    </div>
  );
}
